/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { Box, Grid } from "@mui/material";
import TextInput from "src/components/input/TextInput";
import { perfilesRespToOpcionSelect } from "src/redux/api/types/maestros";
import { useObtenerPerfilesQuery } from "src/redux/api/maestrosApi";
import { useObtenerUsuariosQuery } from "src/redux/api/usuariosApi";
import { usuariosRespToOpcionSelect } from "src/redux/api/types/usuarios";
import { Roles } from "src/utils/roles/roles";
import ComponenteProtegido from "src/pages/ComponenteProtegido";
import {
  IexportarMatrizForm,
  IfiltrosForm,
  esquemaDeValidacionMaestro,
  setValoresInicialesNuevoMaestro,
} from "./utils";
import { ESTADOS_ASPIRANTE_DESCRIPCION } from "src/utils/constantes";
import CustomDialog from "src/components/dialogo/CustomDialog";
import ExportarMatrizForm from "./ExportarMatriz";
import { useLazyObtenerMatrizQuery } from "src/redux/api/documentosSoporteApi";
import { EuiButton } from "@elastic/eui";

export interface MotivoInactivacionProps {
  onFilter: (valores: IfiltrosForm) => void;
}

const FiltrosProyectos = ({ onFilter }: MotivoInactivacionProps) => {
  const [valoresForm, setValoresForm] = useState(
    setValoresInicialesNuevoMaestro,
  );

  const [mostrarAdvertenciaPerfil, setMostrarAdvertenciaPerfil] =
    useState(false);

  const { data: perfilesResp } = useObtenerPerfilesQuery();
  const { data: usuariosResp } = useObtenerUsuariosQuery();

  const [exportarMatriz, { isLoading: descargandoMatriz }] =
    useLazyObtenerMatrizQuery();

  const onExportarMatriz = (values: IexportarMatrizForm) => {
    exportarMatriz(values)
      .unwrap()
      .then((data) => {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "archivo.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={valoresForm}
      validationSchema={esquemaDeValidacionMaestro}
      onSubmit={onFilter}
    >
      {({ values, setFieldValue, handleChange }) => {
        useEffect(() => {
          onFilter(values);
        }, [values]);

        return (
          <Form autoComplete="off" id="form-filtros" style={{ width: "100%" }}>
            <Grid container spacing={0.5}>
              <Grid item xs={1.5} md={1.5}>
                <TextInput label="Identificación" name="identificacion" type="text" />
              </Grid>
              <Grid item xs={1.5} md={1.5}>
                <TextInput
                  label="Nombres"
                  name="nombres"
                  type="text"
                  data-testid="select-id"
                />
              </Grid>
              <Grid item xs={1.5} md={1.5}>
                <TextInput
                  label="Apellidos"
                  name="apellidos"
                  type="text"
                  data-testid="select-id"
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <TextInput
                  label="Perfil"
                  name="perfil"
                  type="select"
                  opciones={
                    perfilesResp
                      ? [
                          { valor: "", label: "Todos" },
                          ...perfilesRespToOpcionSelect(perfilesResp),
                        ]
                      : []
                  }
                  data-testid="select-id"
                />
              </Grid>
              <ComponenteProtegido rolesPermitidos={[Roles.ADMIN]}>
                <Grid item xs={2} md={2}>
                  <TextInput
                    label="Usuario Asignado"
                    name="usuarioAsignadoId"
                    type="select"
                    opciones={
                      usuariosResp
                        ? [
                            { valor: "", label: "Todos" },
                            ...usuariosRespToOpcionSelect(usuariosResp),
                          ]
                        : []
                    }
                    data-testid="select-id"
                  />
                </Grid>
              </ComponenteProtegido>
              <Grid item xs={1.5} md={1.5}>
                <TextInput
                  label="Estado"
                  name="estado"
                  type="select"
                  opciones={[
                    {
                      label: "Todos",
                      valor: "",
                    },
                    ...ESTADOS_ASPIRANTE_DESCRIPCION,
                  ]}
                  data-testid="select-id"
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <EuiButton
                    size="s"
                    fill
                    iconType="symlink"
                    onClick={() => {
                      setMostrarAdvertenciaPerfil(true);
                    }}
                  >
                    Exportar Matriz
                  </EuiButton>
                </Box>
              </Grid>
            </Grid>
            <CustomDialog
              mostrar={mostrarAdvertenciaPerfil}
              onClose={() => {
                setMostrarAdvertenciaPerfil(false);
              }}
              contenido={
                <ExportarMatrizForm
                  handleExportar={onExportarMatriz}
                  cargandoPeticion={descargandoMatriz}
                />
              }
              titulo="Exportar matriz"
              tamanioMaximo="md"
              fullWidth
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default FiltrosProyectos;
